import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="progress-board"
export default class extends Controller {
  static targets = ["container", "projectHeader", "projectContent", "bottomBar"]

  connect() {
    this.handleScroll = this.handleScroll.bind(this)
    this.containerTarget.addEventListener('scroll', this.handleScroll)

    requestAnimationFrame(() => {
      this.updateBottomBar()
    })
  }

  disconnect() {
    this.containerTarget.removeEventListener('scroll', this.handleScroll)
  }

  handleScroll() {
    this.updateBottomBar()
  }

  updateBottomBar() {
    if (!this.hasBottomBarTarget) return

    const containerRect = this.containerTarget.getBoundingClientRect()
    const projects = []

    this.projectHeaderTargets.forEach(header => {
      const contentElement = this.projectContentTargets.find(
        content => content.dataset.projectIndex === header.dataset.projectIndex
      )

      if (!contentElement) return

      const contentRect = contentElement.getBoundingClientRect()

      // コンテンツの下端が画面下部より下にある場合
      if (contentRect.bottom - 60 > containerRect.bottom) {
        projects.push({
          index: header.dataset.projectIndex,
          name: header.dataset.projectName,
          color: header.dataset.projectColor
        })
      }
    })

    if (projects.length === 0) {
      this.bottomBarTarget.innerHTML = ''
      this.bottomBarTarget.classList.remove('visible')
      return
    }

    this.bottomBarTarget.classList.add('visible')
    this.bottomBarTarget.innerHTML = projects.map(cat => `
      <span class="badge project-badge-fixed ${cat.color}"
            data-action="click->progress-board#scrollToProject"
            data-project-index="${cat.index}">
        ${cat.name}
      </span>
    `).join('')
  }

  scrollToProject(event) {
    const clickedElement = event.currentTarget
    const projectIndex = clickedElement.dataset.projectIndex

    const projectHeader = this.projectHeaderTargets.find(
      header => header.dataset.projectIndex === projectIndex
    )

    if (projectHeader) {
      const containerRect = this.containerTarget.getBoundingClientRect()
      const headerRect = projectHeader.getBoundingClientRect()

      let scrollTarget = this.containerTarget.scrollTop + (headerRect.top - containerRect.top)
      // scrollTarget -= 16

      this.containerTarget.scrollTo({
        top: Math.max(0, scrollTarget),
        behavior: 'smooth'
      })
    }
  }
}